<template>
  <ConfirmDialog></ConfirmDialog>
  <ConfirmDialog group="templating">
    <template #message="slotProps">
      <div class="flex p-4">
        <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
        <p class="pl-2">{{ slotProps.message.message }}</p>
      </div>
    </template>
  </ConfirmDialog>
  <ConfirmDialog group="positionDialog"></ConfirmDialog>
</template>

<script>
import ConfirmDialog from "primevue/confirmdialog";

export default {
  emits: ["confirmYes", "confirmNo"],
  components: {
    ConfirmDialog,
  },
  props: {
    showPopup: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: "Do you want to delete this record?",
    },
    header: {
      type: String,
      default: "Delete Confirmation",
    },
  },
  watch: {
    showPopup: {
      handler(newValue) {
        if (newValue === true) {
          this.openPopup();
          document.querySelector("body").style.overflow = "hidden";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openPopup() {
      this.$confirm.require({
        message: this.message,
        header: this.header,
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        accept: () => {
          this.$emit("confirmYes");
          document.querySelector("body").style.overflow = "auto";
        },
        reject: () => {
          this.$emit("confirmNo");
          document.querySelector("body").style.overflow = "auto";
        },
        onHide: () => {
          this.$emit("confirmNo");
          document.querySelector("body").style.overflow = "auto";
        },
      });
    },
  },
};
</script>
